export interface TaskTemplateAssigneeValue {
  id?: string;
  ref?: string;
}

export function resolveTaskTemplateAssigneeId(
  assignee: TaskTemplateAssigneeValue | string | null | undefined,
  existingAssigneeId: string | null | undefined
): string | null {
  if (typeof assignee === 'object' && assignee) {
    return assignee.id || assignee.ref || null;
  }

  if (typeof assignee === 'string' && assignee.trim() && existingAssigneeId) {
    return existingAssigneeId;
  }

  return null;
}
